function BookFactory ($http, config) {
    const { baseUrl } = config

    const getBook = (bookId) => {
        return $http.get(`${baseUrl}/api/books/${bookId}`)
    }

    const generateGuestBook = (interests = []) => (new Promise((resolve, reject) => {
        $http.post(`${baseUrl}/api/guest-book`, {
            interests
        })
            .then((response) => {
                const { bookId } = response.data

                resolve({ bookId })
            }).catch(err => reject(err))
    }))

    const generateFacebookBook = () => (new Promise((resolve, reject) => {
        $http.post(`${baseUrl}/api/facebook-book`)
            .then((response) => {
                const { bookId } = response.data

                resolve({ bookId })
            }).catch(err => reject(err))
    }))

    return {
        getBook,
        generateFacebookBook,
        generateGuestBook
    }
}

BookFactory.$inject = ['$http', 'config']

export default BookFactory



// WEBPACK FOOTER //
// ./client/app/common/user/book.factory.js